
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Color, ColorType, GlobalColor, GradientColorV } from "@/types/colors";
import ColorSwatch from "@/components/Reusable/CustomInputs/Color/ColorSwatch.vue";
import SaveColorDialog from "@/components/Reusable/CustomInputs/Color/SaveColorDialog.vue";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";
import { getGlobalColorCode } from "@/lib/colors/colors";

@Component({
  components: { ColorSwatch, SaveColorDialog }
})
export default class GlobalColorsList extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  value!: GlobalColor[];

  @Prop()
  selectedColor!: Color;

  @Prop()
  selectedGlobalColor!: GlobalColor;

  @Prop({ default: true })
  canSave!: boolean;

  @Prop()
  type!: ColorType;

  get globalColors() {
    return this.value.filter(color => {
      if (!color.value) return false;

      const isGradient = pipe(
        color.value,
        GradientColorV.decode,
        fold(
          () => false,
          () => true
        )
      );

      // Only Show Solid Colors
      if (this.type === "solid" && typeof color.value === "string") {
        const isCssVar = !color.value.includes("var(--");
        return !isGradient && isCssVar;
      }

      // Only Show Gradient Colors
      if (this.type === "radial" || this.type === "linear") {
        return isGradient;
      }

      return false;
    });
  }

  isColorSelected(color: GlobalColor) {
    if (this.selectedGlobalColor) {
      return this.selectedGlobalColor.value === color.value;
    }

    return false;
  }

  getColorCode(color: GlobalColor) {
    return getGlobalColorCode(color);
  }

  onColorSelected(color: GlobalColor) {
    this.$emit("input", color);
  }
}
